export default __webpack_public_path__ + "static/media/pre_built.1ad720b6.png";